import { render } from "./Attachments.vue?vue&type=template&id=bc657906"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import "./Attachments.vue?vue&type=style&index=0&id=bc657906&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/Attachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc657906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc657906', __exports__)) {
    console.log('reload')
    api.reload('bc657906', __exports__)
  }
  
  module.hot.accept("./Attachments.vue?vue&type=template&id=bc657906", () => {
    console.log('re-render')
    api.rerender('bc657906', render)
  })

}


export default __exports__